import { useState } from 'react';
import { Grid, Stack } from '@mantine/core';
import { PlatformFieldset } from '@pac/platform-ui-components';
import { I18n } from '@aws-amplify/core';
import { DocumentationSidebar } from '../components/DocumentationSidebar';
import { DocumentationContent } from '../components/DocumentationContent';

export const IndexPage = () => {
    const [activeTopic, setActiveTopic] = useState('signing-in');

    return (
        <Stack gap="xl">
            <PlatformFieldset legend={I18n.get('Help')}>
                <Grid>
                    <Grid.Col span={3}>
                        <DocumentationSidebar
                            activeTopic={activeTopic}
                            onTopicSelect={setActiveTopic}
                        />
                    </Grid.Col>
                    <Grid.Col span={9}>
                        <DocumentationContent activeTopic={activeTopic} />
                    </Grid.Col>
                </Grid>
            </PlatformFieldset>
        </Stack>
    );
};
